export default __webpack_public_path__ + "static/media/register_3.70ddebf9.jpg";